<template>
  <!--
    The widget is loaded automatically after the script injection.
    Important: it is required to set an id "remark42" for the script
    to recognize the target container
  -->
  <div
    v-if="isWidgetEnabled"
    id="remark42"
    class="comments-widget__wrapper"
  ></div>
</template>

<script>
import { generateIlUrl } from '@/utils/helpers/url-generators'
import { COOKIE_ENTITY_TYPE } from '@/utils/enums/oneTrust'
import mixins from '@/utils/mixins'

export default {
  name: 'ACommentsWidget',
  mixins: [mixins.oneTrust],
  head() {
    if (!this.isWidgetEnabled || !this.isConsentGiven) return

    const inlineConfig = `
      window.remark_config = ${JSON.stringify(this.remarkConfig)};
    `

    return {
      script: [
        {
          hid: 'remark-config',
          type: 'text/javascript',
          innerHTML: inlineConfig
        },
        {
          hid: 'remark-embed',
          src: generateIlUrl('/comments/web/embed.js', this),
          type: 'text/javascript',
          defer: true
        }
      ],
      __dangerouslyDisableSanitizersByTagID: {
        'remark-config': ['innerHTML']
      }
    }
  },
  data() {
    return {
      remark42Instance: null,
      remarkConfig: {
        host: generateIlUrl('/comments', this),
        site_id: this.$env.IL_REMARK42_SITE_ID,
        components: ['embed', 'last-comments'],
        max_shown_comments: 100,
        locale: 'en',
        show_email_subscription: false,
        no_footer: true
      }
    }
  },
  computed: {
    isWidgetEnabled() {
      return !!this.remarkConfig.site_id
    },
    isConsentGiven() {
      return this.$_oneTrust_isConsentGivenForEntity(
        COOKIE_ENTITY_TYPE.REMARK42
      )
    }
  },
  beforeDestroy() {
    if (window.REMARK42 && window.REMARK42.destroy) {
      window.REMARK42.destroy()
    }
  }
}
</script>

<style lang="scss" scoped></style>
